import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Colors } from "@jsq/ds/styles";
import { formatOwnershipDisplay } from "../utils";
import * as styles from "./styles_vanilla.css";
import type { OwnersAndControllersRowItem } from "../types";
import type { OwnershipValidationResult } from "./utils";

export type OwnershipCellRendererParams = {
  data?: OwnersAndControllersRowItem | null;
  validationResult?: OwnershipValidationResult | null;
  [key: string]: unknown;
};

export const OwnershipCellRenderer = (params: OwnershipCellRendererParams) => {
  const data = params.data;
  const validationResult = params.validationResult;
  const profileId = data?.id;
  const hasError = profileId && validationResult?.errorProfileIds.has(profileId);

  return (
    <Flex className={styles.ownershipCellWrapper} alignItems="center">
      <Text variant="regular-md">{formatOwnershipDisplay(data?.ownership)}</Text>
      {hasError && (
        <Icon
          type="exclamation-circle"
          variant="outline"
          color={Colors.Danger600}
          size="small"
          data-testid="ownership-cell-error-icon"
        />
      )}
    </Flex>
  );
};
